import React, { Component } from 'react';
import * as debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import QuickSearch from '../Components/QuickSearch';
import {
    query,
    checkWindowWidth,
    setSearchQuery,
    toggleShowFullForm,
    handleKeyDown,
    onIconSearch,
} from '../Actions/QuickSearch.action';
import {
    toggleOverlay,
    closeOverlay,
    openOverlay,
} from '../Actions/ContentOverlay.action';

class QuickSearchContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
        this.clickHandler = this.clickHandler.bind(this);
        this.clearResults = this.clearResults.bind(this);
        this.lastClickedNode = null;
    }

    componentDidMount() {
        this.props.checkIsOnMobile();
        document.addEventListener('mousedown', this.clickHandler);
        window.addEventListener(
            'resize',
            debounce(this.props.checkIsOnMobile, 200)
        );
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            const { setSearchQuery } = this.props;
            setSearchQuery(query);
        }
    }

    UNSAFE_componentWillUpdate({ showFullForm } = this.props) {
        if (this.state.showFullForm !== showFullForm) {
            this.setState({ ...this.state, showFullForm });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedItem !== prevProps.selectedItem) {
            document
                .querySelector('.quick-search-result__item--selected')
                .scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler);
        window.removeEventListener('resize', this.props.checkIsOnMobile);
    }

    clickHandler(event) {
        this.lastClickedNode = event.target;
    }

    clearResults() {
        this.props.onSearch('');
    }

    render() {
        const { query } = this.props;

        const urlOperator = window.__litium.quickSearchUrl.includes('?')
            ? '&'
            : '?';
        const searchUrl =
            window.__litium.quickSearchUrl +
            (query.length > 0 ? `${urlOperator}q=${query}` : '');

        return (
            <div ref={elem => (this.searchContainer = elem)}>
                <QuickSearch
                    {...{
                        ...this.props,
                        searchUrl,
                        clearResults: () => this.clearResults(),
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        query: state.quickSearch.query,
        result: state.quickSearch.result,
        isMobile: state.quickSearch.isMobile,
        showResult: state.quickSearch.showResult,
        showFullForm: state.quickSearch.showFullForm,
        selectedItem: state.quickSearch.selectedItem,
        resultMobile: state.quickSearch.resultMobile,
        resultDesktop: state.quickSearch.resultDesktop,
        links: state.navigation.contentLinks,
    };
};

const createDebouncedQuery = timeout =>
    debounce((dispatch, text) => dispatch(query(text)), timeout);

const mapDispatchToProps = (dispatch, ownProps) => {
    const { quickSearchDebounceTimeout = 200 } = ownProps;
    const debouncedQuery = createDebouncedQuery(quickSearchDebounceTimeout);
    return {
        onSearch: text => {
            dispatch(setSearchQuery(text));
            debouncedQuery(dispatch, text);
        },
        toggleShowFullForm: () => dispatch(toggleShowFullForm()),
        onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
        toggleOverlay: () => dispatch(toggleOverlay()),
        closeOverlay: () => dispatch(closeOverlay()),
        openOverlay: () => dispatch(openOverlay()),
        onIconSearch: (event, opt) => dispatch(onIconSearch(event, opt)),
        checkIsOnMobile: () => dispatch(checkWindowWidth()),
        setSearchQuery: text => dispatch(setSearchQuery(text)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickSearchContainer);
